_reduce = require('lodash/reduce')
module.exports = {
  duration: (ticket) ->
    _reduce(ticket.segment_durations, ((sum, num) -> sum + num), 0)
  is_direct: (ticket) ->
    ticket.max_stops is 0
  departure_timestamp: (ticket) ->
    ticket.segment[0].flight[0].departure_timestamp
}
